export const stringsKey = "RecurringSchedulerDialog";
export const englishStrings = {
	dialogTitle: "Recurrence Pattern",
	dailyRecurrencePattern: "Message will be sent Monday through Sunday at",
	dailyRecurrenceFrom: "each day beginning from",
	weeklyRecurrenceInfo:
		"Select the days of the week on which to send the message.",
	weeklyRecurrencePatternStart: "Message will be sent at",
	weeklyRecurrencePatternOn: "on ",
	weeklyRecurrencePatternFrom: "from",
	sendOn: "Send on: ",
	monthlyRecurrenceInfo:
		"Select the date of the month on which the message will be sent. The first message will be sent on",
	monthlyRecurrenceAt: "at",
	monthlyRecurrenceFrom:
		"and each subsequent month, the message will be sent on the day from the date below.",
	monthlyDateRangeWarning:
		"You have selected a date which not all months have. If a month does not include this date your message will be sent on the final day of the month.",
	recurrenceMonday: "Monday",
	recurrenceTuesday: "Tuesday",
	recurrenceWednesday: "Wednesday",
	recurrenceThursday: "Thursday",
	recurrenceFriday: "Friday",
	recurrenceSaturday: "Saturday",
	recurrenceSunday: "Sunday",
};
